import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, 
// CardActions,
CardMedia, CardContent, Typography, } from '@mui/material';
import { useConversationStore } from '../ConversationStoreProvider';
import Image from './Image';
import ItemTitle from './ItemTitle';
import { buildPortalAbsoluteHref, getPortalBasePath, resolvePortalItemRelativeUrl, toPortalRouterRelativePath, } from './portalNavigation';
const WebPageCard = ({ title, image, description, url, width, openInNewTab, config = WebPageCard.defaultProps.config, customStyle, onPortalRelativeNavigate, itemType, organizationID, entityId, slug, }) => {
    const conversationStore = useConversationStore();
    const rootPath = getPortalBasePath();
    const safeUrl = resolvePortalItemRelativeUrl({
        url,
        type: itemType,
        organizationID,
        id: entityId,
        slug,
    });
    const routerRelative = toPortalRouterRelativePath(safeUrl, rootPath);
    const absoluteHref = buildPortalAbsoluteHref(rootPath, safeUrl);
    const sameTabFallbackHref = absoluteHref;
    const handleClick = (e) => {
        conversationStore.currentConversation?.sendTrackingEvent('web_page_click', {
            page_name: title,
            page_url: safeUrl,
        });
        if (openInNewTab) {
            e.preventDefault();
            const w = window.open(absoluteHref, '_blank', 'noopener,noreferrer');
            if (w)
                w.opener = null;
            return;
        }
        if (onPortalRelativeNavigate && routerRelative) {
            e.preventDefault();
            onPortalRelativeNavigate(routerRelative);
        }
    };
    return (_jsx("a", { href: openInNewTab ? absoluteHref : sameTabFallbackHref, target: openInNewTab ? '_blank' : undefined, rel: openInNewTab ? 'noopener noreferrer' : undefined, onClick: handleClick, children: _jsxs(Card, { sx: {
                width,
                boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important',
                ...customStyle,
            }, children: [_jsx(CardMedia, { children: config.courseCardShowImage && (_jsx(Image, { url: image, status: "loaded", alt: title, customStyle: { width: '100%' }, 
                        // blank image
                        fallbackSrc: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" })) }), _jsxs(CardContent, { sx: {
                        p: 1,
                        '&:last-child': {
                            pb: 1,
                        },
                    }, children: [config.courseCardShowTitle && (_jsx(ItemTitle, { title: title })), config.courseCardShowDesc && (_jsx(Typography, { component: "div", variant: "body1", className: "description", sx: {
                                display: '-webkit-box',
                                WebkitLineClamp: config.courseCardMaxLinesDescription,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                maxHeight: `${config.courseCardMaxLinesDescription * 1.5}em`,
                            }, children: description }))] })] }) }));
};
WebPageCard.defaultProps = {
    onPortalRelativeNavigate: undefined,
    config: {
        courseCardShowImage: true,
        courseCardShowTitle: true,
        courseCardShowInstructor: false,
        courseCardShowPrice: false,
        courseCardShowButton: false,
        courseCardMaxLinesDescription: 4,
    },
    customStyle: undefined,
};
export default WebPageCard;
//# sourceMappingURL=WebPageCard.js.map